import Analytics from '@/utils/analytics';
import FileIcon from '@assets/icons/file.svg';
import React from 'react';
import { ChatTime } from './chat-time';
import { createStyles } from '@/contexts/theme-context';
import { getChatMessageBorderColor } from './constants';
import { Message } from './types';
import { MessageImageProps } from 'react-native-gifted-chat';
import { openPDF } from '@/utils/navigation';
import { StyleSheet, Text, TouchableOpacity, View } from 'react-native';
import { TYPOGRAPHY } from '@/styles';

const decodeString = (s: string) => {
  try {
    return decodeURIComponent(s);
  } catch {
    return s;
  }
};

export const ChatMessageFile: React.FC<MessageImageProps<Message>> = (
  props,
) => {
  const [styles, theme] = useStyles();

  const mediaURL = props.currentMessage?.image as string;
  const buttonText = decodeString(mediaURL.split('/').pop() ?? '');

  const hasAttachedMessage = props.currentMessage?.text;

  return (
    <TouchableOpacity
      activeOpacity={0.8}
      onPress={() => {
        Analytics.track('chat_message.file.press');

        openPDF(mediaURL);
      }}
      testID="file-button"
    >
      <View style={styles.base}>
        <View style={styles.buttonIcon}>
          <FileIcon fill={theme.colors.white} />
        </View>
        <Text
          ellipsizeMode="middle"
          numberOfLines={2}
          style={[TYPOGRAPHY.pSemiBold, styles.buttonText]}
        >
          {buttonText}
        </Text>
      </View>
      {!hasAttachedMessage ? (
        <View style={styles.timeContainer}>
          {
            // `position` isn't defined in props but Bubble passes it in
            // @ts-ignore
            <ChatTime {...props} />
          }
        </View>
      ) : null}
    </TouchableOpacity>
  );
};

const useStyles = createStyles((theme) => ({
  base: {
    alignItems: 'center',
    borderBottomColor: getChatMessageBorderColor(theme),
    borderBottomWidth: StyleSheet.hairlineWidth,
    flexDirection: 'row',
    padding: 8,
  },
  buttonIcon: {
    height: 28,
    marginRight: 11,
    width: 22,
  },
  buttonText: {
    flex: 1,
  },
  timeContainer: {
    padding: 8,
  },
}));
